import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation    from './components/Navigation/Navigation';
import Home          from './components/Home/Home';
import Footer        from './components/Footer/Footer';
import CampusCharter from './components/CampusCharter/CampusCharter';

export default function App() {
  return (
    <BrowserRouter>
      <div className="w-full min-h-screen" style={{ background: '#1a1a1a' }}>
        <Navigation />
        <main>
          <Routes>
            <Route path="/"               element={<Home />} />
            <Route path="/campus-charter" element={<CampusCharter />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
